const Education = () => {
  return (
    <div id="education" className="resume-section">
      <h4>Education</h4>

      <span className="experience">
        <span className="title">Northern Michigan University</span>
        <span className="caption">Bachelor of Fine Arts in Graphic Design &bull; May 2014</span>
        <p></p>
      </span>
    </div>
  );
};

export default Education;